export function apiSidebarAccordion() {
  $('.sidebar-accord-title').on('click', function () {
    var parent = $(this).closest('.accordion-card');
    parent.toggleClass('active');
    parent.find('.sidebar-accord-content').slideToggle();

    if (parent.hasClass('active')) {
      parent.find('i').removeClass('fa-caret-up').addClass('fa-caret-down');
    } else {
      parent.find('i').removeClass('fa-caret-down').addClass('fa-caret-up');
    }
  })
}